var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPencilIcon = function SvgPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M9.453 2.744l3.805 3.805-8.508 8.508-4.75.945.945-4.75 8.508-8.508zM15.211.791a2.683 2.683 0 010 3.805l-1.242 1.25-3.805-3.805 1.242-1.25a2.683 2.683 0 013.805 0z"
  })));
};
export default SvgPencilIcon;